import Vue from 'vue'
import * as VueGoogleMaps from 'vue2-google-maps'

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyAYGzYsPDxu2KdfBsq9aUiaKYitn5qvRMc',
    installComponents: false,
    libraries: 'places' // necessary for places input
  }
})
